<template>
  <div class="container-fluid mt-5">
    <div>
      <card
        class="no-border-card"
        body-classes="px-0 pb-1"
        footer-classes="pb-2"
      >
        <template slot="header">
          <div class="row">
            <div class="col-6">
              <h3 class="mb-0">
                {{ $t("SALES_ORDERS.SALES_ORDERS_LIST") }}
              </h3>
            </div>
            <div class="col-6 text-right">
              <help-button context="sales-orders" />
              <!-- <base-button
                type="primary"
                icon
                size="sm"
                @click="addSalesOrder()"
                v-if="$currentUserCan($permissions.PERM_CREATE_SALES_ORDERS)"
              >
                <span class="btn-inner--icon">
                  <i class="fas fa-plus"></i>
                </span>
                <span class="btn-inner--text">
                  {{ $t("SALES_ORDERS.ADD_SALES_ORDER") }}
                </span>
              </base-button> -->

              <notification-subscription
                v-if="$currentUserCan($permissions.PERM_VIEW_SALES_ORDERS)"
                :objectType="'sales-orders'"
                :events="{
                  CREATE: $t('NOTIFICATIONS.EVENT_CREATE'),
                  UPDATE: $t('NOTIFICATIONS.EVENT_UPDATE'),
                  DELETE: $t('NOTIFICATIONS.EVENT_DELETE'),
                }"
              />
            </div>
          </div>
        </template>

        <sales-order-list-table
          :filterEstablishment="$route.query.establishment || null"
        />
      </card>
    </div>
  </div>
</template>
<script>
import { Button } from "element-ui";
import NotificationSubscription from "@/components/NotificationSubscription.vue";
import SalesOrderListTable from "./partials/SalesOrderListTable.vue";

export default {
  layout: "DashboardLayout",

  components: {
    SalesOrderListTable,
    NotificationSubscription,
    [Button.name]: Button,
  },

  mixins: [],

  computed: {},

  watch: {},

  methods: {
    addSalesOrder() {
      this.$router.push({ name: "Add SalesOrder" });
    },
  },
};
</script>
